export default "__VITE_ASSET__tZoVevt2__"